const pxToNumber = (px)=>{
    if (!px || 'string' != typeof px) return 0;
    const num = parseFloat(px.replace('px', ''));
    return isNaN(num) ? 0 : num;
};
export { pxToNumber };
